import $ from 'jquery';
import { v1BaseUrl } from '@shared/js/apiV1.js';
import { escapeHtml } from '@shared/js/toasts.js';

// Retrieve announcements from the API
export async function fetchAnnouncements() {
  try {
    const res = await fetch(v1BaseUrl + 'app/announcements');
    if (!res.ok) {
      return [];
    }
    const data = await res.json();
    if (Array.isArray(data.announcements)) {
      return data.announcements;
    }
  } catch (e) {
    console.error('Failed to fetch announcements', e);
  }
  return [];
}

// Map API announcement types to Bootstrap alert classes
export function typeToBootstrap(type) {
  switch ((type || '').toLowerCase()) {
    case 'alert':
      return 'danger';
    case 'warning':
      return 'warning';
    default:
      return 'secondary';
  }
}

// Single module-level refresh timer. renderAnnouncements() runs on every
// library / sign-in render with a brand-new container, so storing the timer
// on the container leaked one 30s fetch loop per navigation. The timer also
// stops itself once its wrapper leaves the DOM and skips refreshes while the
// tab is hidden.
let announcementsIntervalId = null;

// Render announcements into the given container element
export function renderAnnouncements(container) {
  if (announcementsIntervalId) {
    clearInterval(announcementsIntervalId);
    announcementsIntervalId = null;
  }

  const wrapper = $('<div class="sv-announcements"></div>');
  container.append(wrapper);

  async function update() {
    const list = await fetchAnnouncements();
    wrapper.empty();
    list.forEach(a => {
      const cls = typeToBootstrap(a.type);
      const alert = $(
        `<div class="alert alert-${cls} mt-3" role="alert"><strong>${escapeHtml(a.headline)}</strong><br>${escapeHtml(a.body)}</div>`
      );
      wrapper.append(alert);
    });
  }

  update();
  announcementsIntervalId = setInterval(() => {
    // Stop refreshing once this render has been replaced by another view.
    if (!document.body.contains(wrapper[0])) {
      clearInterval(announcementsIntervalId);
      announcementsIntervalId = null;
      return;
    }
    if (!document.hidden) {
      update();
    }
  }, 30000); // refresh every 30 seconds
}
